import type { CategoryType, ServiceType } from '../../types'
import type {
    ITeamForm,
    ITeamManagmant,
    ITeamOne,
} from '../../types/tenant/team.types'
import { baseApi } from '../baseApi'
import type {
    IDashboardData,
    ITenantUser,
    ResponseType,
    ServiceFormType,
    ServicesByIDResponeDataType,
} from '../types'

const webBase = '/api/tenants/teams'

export const teamManagement = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllTeams: builder.query<ResponseType<ITeamManagmant[]>, string>({
            query: (qwery) => `${webBase}?${qwery}`,
            providesTags: ['teamManagement'],
        }),
        getTeamById: builder.query<ResponseType<ITeamOne>, number>({
            query: (id) => `${webBase}/${id}`,
            providesTags: ['teamManagement'],
        }),
        createTeam: builder.mutation<ResponseType<ITeamManagmant>, ITeamForm>({
            query: (body) => ({
                url: `${webBase}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['teamManagement'],
        }),
        updateTeam: builder.mutation<
            ResponseType<ITeamManagmant>,
            { teamId: string | number; body: ITeamForm }
        >({
            query: ({ teamId, body }) => ({
                url: `${webBase}/${teamId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['teamManagement'],
        }),
        deleteTeam: builder.mutation<
            ResponseType<ITeamManagmant>,
            number | string
        >({
            query: (teamId) => ({
                url: `${webBase}/${teamId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['teamManagement'],
        }),
    }),
})

export const {
    useGetAllTeamsQuery,
    useGetTeamByIdQuery,
    useCreateTeamMutation,
    useUpdateTeamMutation,
    useDeleteTeamMutation,
    useLazyGetAllTeamsQuery,
} = teamManagement
